module.exports = __webpack_public_path__ + "img/icon1.ab1476aa.png";